import { forwardRef, InputHTMLAttributes } from 'react';

import { TextInput } from '../../inputs/TextInput/TextInput';
import { DefaultFormFieldLayout } from '../DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '../FormFieldHelperText/FormFieldHelperText';

export const DEFAULT_TIME_FORMAT = 'hh:mm a';

type CoreFormFieldTimeProps = {
  inputProps: InputHTMLAttributes<HTMLInputElement>;
  label?: React.ReactNode;
  error?: string;
  helperText?: HelperText;
  inline?: boolean;
};

export const CoreFormFieldTime = forwardRef(function _CoreFormFieldTime(
  { error, helperText, inline, inputProps, label }: CoreFormFieldTimeProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      error={error}
      inputId={inputProps.id}
      inline={inline}
      helperText={helperText}
    >
      <div className="flex items-center gap-2">
        <TextInput
          data-testid={inputProps.id || 'time-input'}
          placeholder={inputProps.placeholder || DEFAULT_TIME_FORMAT}
          {...inputProps}
          type="time"
          ref={ref}
          autoFocus={false}
          // prevent typing in anything not timey wimey
          // https://digitalfortress.tech/tips/top-15-commonly-used-regex/
          pattern="/((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/"
        />
      </div>
    </DefaultFormFieldLayout>
  );
});
